// Değerler Carbon dayOfWeek konvansiyonu (0=Pazar .. 6=Cumartesi) — backend
// WorkingDayService/GenerateRoutineExecutions bu sayıları bekliyor, bu yüzden
// DEĞERLER değişmemeli. Sadece GÖSTERİM sırası Türkiye'ye göre: hafta
// Pazartesi başlar, Pazar son gündür.
export const ROUTINE_WEEKDAY_OPTIONS = [
  { value: 1, label: 'Pazartesi' },
  { value: 2, label: 'Salı' },
  { value: 3, label: 'Çarşamba' },
  { value: 4, label: 'Perşembe' },
  { value: 5, label: 'Cuma' },
  { value: 6, label: 'Cumartesi' },
  { value: 0, label: 'Pazar' },
];

export const weekdayLabel = (value) =>
  ROUTINE_WEEKDAY_OPTIONS.find((o) => o.value === value)?.label || '?';

// Seçili günleri listede gösterirken de aynı sıra kullanılmalı — kayıttaki
// dizi [0,1,5] gibi ham sırada gelebiliyor.
export const sortWeekdays = (values = []) =>
  [...values].sort(
    (a, b) =>
      ROUTINE_WEEKDAY_OPTIONS.findIndex((o) => o.value === a) -
      ROUTINE_WEEKDAY_OPTIONS.findIndex((o) => o.value === b)
  );

// ---- Aylık tekrar ----------------------------------------------------

export const ROUTINE_FREQUENCY_OPTIONS = [
  { value: 'weekly', label: 'Haftalık' },
  { value: 'monthly', label: 'Aylık' },
];

export const ROUTINE_MONTHLY_MODE_OPTIONS = [
  { value: 'day_of_month', label: 'Ayın belirli günleri' },
  { value: 'nth_weekday', label: 'Ayın kaçıncı günü' },
];

// 5 = SON (backend'de Routine::WEEK_LAST). 4 ile "Son" bilerek farklı: 5
// pazartesili bir ayda "4." dördüncüyü, "Son" beşinciyi işaret eder.
export const ROUTINE_MONTH_WEEK_OPTIONS = [
  { value: 1, label: '1.' },
  { value: 2, label: '2.' },
  { value: 3, label: '3.' },
  { value: 4, label: '4.' },
  { value: 5, label: 'Son' },
];

export const MONTH_DAY_OPTIONS = Array.from({ length: 31 }, (_, i) => ({
  value: i + 1,
  label: String(i + 1),
}));

/**
 * Bir rutinin tekrar kuralını listede gösterilecek kısa metne çevirir.
 * Aylık rutinde "Günler" kolonu boş kalmasın diye — weekdays aylıkta [] olur.
 */
export const scheduleSummary = (routine) => {
  if (routine?.frequency !== 'monthly') {
    return sortWeekdays(routine?.weekdays || []).map(weekdayLabel).join(', ');
  }

  if (routine.monthly_mode === 'nth_weekday') {
    const week = ROUTINE_MONTH_WEEK_OPTIONS.find((o) => o.value === routine.month_week)?.label || '?';
    return `Her ayın ${week} ${weekdayLabel(routine.month_weekday)} günü`;
  }

  const days = [...(routine.month_days || [])].sort((a, b) => a - b);
  return days.length ? `Her ayın ${days.join(', ')}. günü` : 'Aylık';
};
